import { AnimationControls } from 'framer-motion';

import { QuickActionDto, QuickActionDtoType } from '@/api/generated';
import HubspotLogo from '@/assets/third-party-logos/hubspot/hubspot.svg';

import { MenuItem, Row, SmallSelect, LargeSelect, UserSelectContainer } from './AgentStyle';
import AgentWrapper from './AgentWrapper';
import HubspotCompanySelect from './HubspotCompanySelect';
import HubspotUsersSelect from './HubspotUsersSelect';
import QuickActionAnimationWrapper from './QuickActionAnimationWrapper';
import { AiGeneratedTextContainer, AiGeneratedText } from './QuickActionStyle';
import { useSummaryQuickActionLogic } from './hooks/useSummaryQuickActionLogic';
import { HubspotProviderOptions } from './types';

const agentText = {
  title: 'This summary was found on ',
  text: 'Do you want me to archive this in your platform?'
};

interface QuickActionProps {
  quickAction: QuickActionDto;
  index: number;
  firstQuickActionControls: AnimationControls;
  secondQuickActionControls: AnimationControls;
}

const SummaryQuickAction = ({
  quickAction,
  index,
  firstQuickActionControls,
  secondQuickActionControls
}: QuickActionProps) => {
  const {
    meetingAnalysis,
    event,
    provider,
    providerOption,
    setProviderOption,
    selectedUsers,
    setSelectedUsers,
    selectedCompanies,
    setSelectedCompanies
  } = useSummaryQuickActionLogic({
    quickAction,
    index
  });

  return (
    <QuickActionAnimationWrapper
      quickActionId={quickAction.id!}
      index={index}
      firstQuickActionControls={firstQuickActionControls}
      secondQuickActionControls={secondQuickActionControls}
    >
      <>
        {meetingAnalysis?.items?.[0].calendarEventId && quickAction.type && (
          <AgentWrapper
            title={agentText.title}
            titleUnderlined={event?.title || ''}
            bubbleText={agentText.text}
          >
            <Row>
              <SmallSelect
                disabled
                value={provider}
                renderValue={() => (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <img src={HubspotLogo} alt="" width="20" height="20" />
                    {provider}
                  </div>
                )}
              >
                <MenuItem value={provider}>
                  <img src={HubspotLogo} alt="" />
                  {provider}
                </MenuItem>
              </SmallSelect>

              <LargeSelect
                renderValue={value => String(value)}
                value={providerOption}
                onChange={e => setProviderOption(e.target.value as string)}
              >
                {[HubspotProviderOptions.Contacts, HubspotProviderOptions.Company].map(option => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </LargeSelect>
            </Row>
            <Row>
              {providerOption === HubspotProviderOptions.Contacts ? (
                <UserSelectContainer>
                  <HubspotUsersSelect
                    users={[]}
                    selectedUsers={selectedUsers}
                    setSelectedUsers={setSelectedUsers}
                  />
                </UserSelectContainer>
              ) : (
                <UserSelectContainer>
                  <HubspotCompanySelect
                    companies={[]}
                    selectedCompanies={selectedCompanies}
                    setSelectedCompanies={setSelectedCompanies}
                  />
                </UserSelectContainer>
              )}
            </Row>
          </AgentWrapper>
        )}

        {quickAction.type === QuickActionDtoType.emailReply && <div>email reply</div>}
        {quickAction.type === QuickActionDtoType.meetingSummarySync && (
          <AiGeneratedTextContainer>
            {meetingAnalysis?.items?.[0].sections?.map(section => (
              <AiGeneratedText key={section.title}>
                {section.title}
                <br />
                {section.content}
              </AiGeneratedText>
            ))}
          </AiGeneratedTextContainer>
        )}
      </>
    </QuickActionAnimationWrapper>
  );
};

export default SummaryQuickAction;
